module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/smsby-location/campaign-details/campaign-details.component.css
// module id = ./src/app/allocation/smsby-location/campaign-details/campaign-details.component.css
// module chunks = main